export const colors = {
  brand: '#2563eb',
  brandLight: '#3b82f6',
  brandDark: '#1d4ed8',
  success: '#10b981',
  warning: '#f59e0b',
  danger: '#ef4444',
  // Status palette (CLAUDE.md design-system section). Refreshed 2026-05-23
  // to encode a severity gradient: healthy (green) → notable (orange) →
  // neutral (slate) → info-needed (violet) → problem (red). Red moved from
  // Stopped → Offline (Offline is the actual incident state); Stopped is
  // now neutral slate; Pending is violet (signal-searching, distinct from
  // every other status, reads as info/processing without alarming).
  statusMoving: '#10b981',
  statusStopped: '#64748b',
  statusIdle: '#f59e0b',
  statusOffline: '#dc2626',
  statusPending: '#8b5cf6',
  // Surface
  background: '#f8fafc',      // slate-50
  surface: '#ffffff',
  sidebarDark: 'rgba(15,23,42,0.92)',
  text: '#0f172a',            // slate-900
  textMuted: '#64748b',       // slate-500
  border: '#e2e8f0',          // slate-200
} as const;

export const radii = {
  sm: 6,
  md: 10,
  lg: 12,                      // 0.75rem — default
  xl: 20,                      // 1.25rem — card radius
} as const;

export const spacing = {
  xs: 4,
  sm: 8,
  md: 12,
  lg: 16,
  xl: 24,
  '2xl': 32,
} as const;

export const fontFamily = {
  sans: 'DM Sans, system-ui, sans-serif',
} as const;

export const mapDefaults = {
  center: [44.3661, 33.3152] as [number, number],  // Baghdad — matches config/themes/default.json
  zoom: 6,
  styleLight: 'https://tiles.openfreemap.org/styles/liberty',
  styleDark: 'https://tiles.openfreemap.org/styles/dark',
  // No `styleSatellite` here on purpose: satellite is a raster style object,
  // not a URL. Mobile builds it in `src/features/map/mapStyles.ts`, web in
  // `src/features/map/basemapCatalog.js`. The URL that used to live here
  // carried MapTiler's documentation placeholder key and 403'd on every load.
} as const;

export type ColorToken = keyof typeof colors;
